import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

export const MobileManUserModel = ({ isOpen, toggle, itemList, onRowSelected, refTypeSelected, fromLocationSelect, gridData }) => {

    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);


    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
    };


    useEffect(() => {
        if (isOpen) {
            setPageNo(1);
        }
    }, [isOpen]);

    const indexOfLastPost = pageNo * pageSize;
    const indexOfFirstPost = indexOfLastPost - pageSize;
    const currentPosts = itemList.slice(indexOfFirstPost, indexOfLastPost);

    return (
        <div>
            <Modal
                size="xl"
                isOpen={isOpen}
                toggle={toggle}
                style={{ maxWidth: '90%', width: '90%' }}
                centered={true}
                backdrop="static">

                <ModalHeader toggle={toggle}>Select Document No</ModalHeader>

                <ModalBody>
                    <Row className="mb-4"> {/* Add bottom margin to the Row */}
                        <Col>
                            <div className="mx-4">
                                <table className="custom-table table-bordered table-sm rounded mx-auto mb-4">
                                    <thead className="table-secondary">
                                        <tr style={{ height: '40px' }}>
                                            <td style={{ fontWeight: 'bold' }}>#</td>
                                            <td>Document No</td>
                                            <td>User</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPosts.map((item, index) => (
                                            <tr key={index} onClick={() => {
                                                onRowSelected(item, refTypeSelected, fromLocationSelect, gridData);
                                                toggle();
                                            }}>
                                                <td>{indexOfFirstPost + index + 1}</td>
                                                <td>{item.documentNo}</td>
                                                <td>{item.userName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(itemList.length / pageSize)}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                forcePage={pageNo - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-center pagination-sm'}
                            />
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    );
};
